// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wbFn","content":"styles_content__14sx1"};